// extracted by mini-css-extract-plugin
export var container = "MainVisualSection-module--container--3oeCf";
export var mvContainer = "MainVisualSection-module--mvContainer--Ti8kn";
export var paragraphContainer = "MainVisualSection-module--paragraph-container--3Vj1n";
export var title = "MainVisualSection-module--title--d9K-k";
export var paragraph = "MainVisualSection-module--paragraph--3x9dt";